const findPwd = {
  name: 'findPwd',
  path: 'findPwd',
  component: resolve => require(['../../../pages/custom/find-pwd'], resolve)
}

export default findPwd
